export default __webpack_public_path__ + "static/media/anexet.47d56e30.jpg";